import React, { useEffect, useState } from "react";
import QuizFrame from "../../components/quiz/quizFrame";
import Button from "../../components/common/button";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getQuizData } from "../../redux/slices/quizSlice";
import BackdropSpinner from "../../components/backdropSpinner";

const Quiz = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { quiz, loading, error } = useSelector((state) => state.quiz);

  // State to track selected options
  const [selectedOptions, setSelectedOptions] = useState({});

  //  useEffect - Fetch quiz data if not already loaded
  useEffect(() => {
    if (!quiz.length) {
      dispatch(getQuizData());
    }
  }, [dispatch, quiz.length]);

  // useEffect - Handle API errors during data fetch
  useEffect(() => {
    if (error) {
      toast.error("Error fetching quiz data: " + error);
    }
  }, [error]);

  // handleOptionSelect - Update the selected option for a specific question
  const handleOptionSelect = (questionId, selectedOption) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [questionId]: selectedOption,
    }));
  };

  // handleNextButton - Navigate to the next step after validation
  const handleNextButton = () => {
    const allAnswered = quiz
      .filter((question) => question.is_active) // Only consider active questions
      .every((question) => selectedOptions.hasOwnProperty(question.id));

    if (!allAnswered) {
      toast.error("Please answer all questions before proceeding.");
      return;
    }

    navigate("/"); // Navigate to the next page
  };

  // Display a loading spinner while quiz data is being fetched
  if (loading) {
    return <BackdropSpinner />;
  }

  return (
    <>
      <div className="p-5">
        {/* Render each active quiz question */}
        {quiz
          .filter((questionData) => questionData.is_active) // Filter out inactive questions
          .map((questionData) => (
            <div key={questionData.id} className="mb-24 mt-16">
              <QuizFrame
                question={questionData.question}
                option1={questionData.option1}
                option2={questionData.option2}
                correctOption={questionData.correct_option}
                onSelectOption={(selectedOption) =>
                  handleOptionSelect(questionData.id, selectedOption)
                }
                selectedOption={selectedOptions[questionData.id]}
              />
            </div>
          ))}
      </div>

      {/* Button to navigate to the next step */}
      <div className="flex justify-center">
        <Button text={"Next"} onClick={handleNextButton} />
      </div>
    </>
  );
};

export default Quiz;
